/**
 * Returns true if this account is a synthetic load-test user that should be
 * excluded from all user lists, counts, reports, and analytics.
 *
 * Matches:
 *   email  — ends with @workplace-readiness.local
 *   name   — starts with "Load Applicant" (case-insensitive)
 */
export const isLoadTestUser = (user) => {
  const email = (user.email || '').toLowerCase();
  const name = (user.displayName || user.name || '').toLowerCase();
  return (
    email.endsWith('@workplace-readiness.local') ||
    name.startsWith('load applicant')
  );
};

/** Convenience inverse — pass directly to Array.filter */
export const isRealUser = (user) => !isLoadTestUser(user);
